import { render, staticRenderFns } from "./ChatSender.vue?vue&type=template&id=ea179f9e&scoped=true"
import script from "./ChatSender.vue?vue&type=script&lang=js"
export * from "./ChatSender.vue?vue&type=script&lang=js"
import style0 from "./ChatSender.vue?vue&type=style&index=0&id=ea179f9e&prod&lang=css"
import style1 from "./ChatSender.vue?vue&type=style&index=1&id=ea179f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea179f9e",
  null
  
)

export default component.exports